import { CLWS_CORAL_CONFIG, URL_PREFIXES } from './endpointConfig';

const getEnv = () => {
  const url = window.location.href;
  let env;
  if (url.includes(URL_PREFIXES.BETA_URL_PREFIX)) {
    env = CLWS_CORAL_CONFIG.BETA_CONFIG;
  } else if (url.includes(URL_PREFIXES.GAMMA_URL_PREFIX)) {
    env = CLWS_CORAL_CONFIG.GAMMA_CONFIG;
  } else if (url.includes(URL_PREFIXES.PROD_URL_PREFIX)) {
    env = CLWS_CORAL_CONFIG.PROD_CONFIG;
  } else {
    env = CLWS_CORAL_CONFIG.LOCAL_DEV;
  }
  return env;
};

const envHelper = {
  getEnv,
};

export default envHelper;